'use strict';

import * as types from '../../types';
import actions from './actions';
import ua from '../../../libs/user-agenet';

let state = {
  deviceName:  null,
  browserName: null,
  osName:      null,
  mode:        null,
  token:       null
};

function getParam(name, url){
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let mutations = {
  /**
   * デバイス情報をステートに格納
   * @param state
   */
  [types.INITIALIZE_DEVICE_INFO](state){
    // detect.min.jsにてユーザエージェントのデコードを行う
    let uaData        = ua.getUserAgentData(navigator.userAgent);
    state.deviceName  = uaData.device;
    state.browserName = uaData.browser + '_' + uaData.browserVersion;
    state.osName      = uaData.os + '_' + uaData.osVersion;
    state.mode        = getParam('type');
    state.toekn       = getParam('token');
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/device/store.js